var KlaviyoSubscribe = KlaviyoSubscribe || {};
! function() {
    if (!KlaviyoSubscribe._loaded) {
        KlaviyoSubscribe._loaded = !0;
        var e = {
                "modal.html": '<div class="klaviyo_modal" style="display:none;"><div class="klaviyo_inner"><a href="#" class="klaviyo_close_modal klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_fieldset"></div><div class="klaviyo_fine_print"></div><div class="klaviyo_form_actions"><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="klaviyo_below_submit"></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',
                "flyout.html": '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_flyout_action"><a href="#"><span /> &raquo;</a></div></div></div>',
                "flyout_form.html": '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_inline_fieldset"><input type="email" name="email" placeholder="Your email address" /><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>'
            },
            i = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            a = {
                $email: "Email Address",
                $first_name: "First Name",
                $last_name: "Last Name"
            },
            s = "klaClosedPopup";
        KlaviyoSubscribe._debug = -1 < document.location.hash.indexOf("#test"), KlaviyoSubscribe.has_called_bootstrap = !1, KlaviyoSubscribe.is_requirements_loaded = !1, KlaviyoSubscribe.bootstrap_queue = [], KlaviyoSubscribe.bootstrap_attempts = 0, KlaviyoSubscribe.instances = {}, KlaviyoSubscribe.isDebugMode = function() {
            return KlaviyoSubscribe._debug
        }, KlaviyoSubscribe.bootstrap = function(e) {
            KlaviyoSubscribe.has_called_bootstrap || (KlaviyoSubscribe.has_called_bootstrap = !0, KlaviyoSubscribe.loadCss("//a.klaviyo.com/media/css/public/klaviyo_subscribe.css"), KlaviyoSubscribe.fetchRequirements(e))
        }, KlaviyoSubscribe.setHasClosedModalCookieName = function(e) {
            s = e || s
        }, KlaviyoSubscribe.loadScript = function(e, i, a) {
            var s = document.getElementsByTagName("head")[0],
                o = document.createElement("script");
            o.type = "text/javascript", o.src = e, s.appendChild(o), KlaviyoSubscribe.log("Loaded JS", e), KlaviyoSubscribe.whenTrue(i, a)
        }, KlaviyoSubscribe.loadCss = function(e) {
            var i = document.getElementsByTagName("head")[0],
                a = document.createElement("link");
            a.rel = "stylesheet", a.type = "text/css", a.href = e, i.appendChild(a), KlaviyoSubscribe.log("Loaded CSS", e)
        }, KlaviyoSubscribe.injectCSS = function(e) {
            var i = document.getElementsByTagName("head")[0],
                a = document.createElement("style");
            a.type = "text/css", a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e)), i.appendChild(a)
        }, KlaviyoSubscribe.whenTrue = function(e, i) {
            var a = 0,
                s = function() {
                    e() ? i() : 100 > ++a && setTimeout(s, 200)
                };
            s()
        }, KlaviyoSubscribe.loadJQuery = function(e) {
            KlaviyoSubscribe.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js", function() {
                return !!window.jQuery
            }, e)
        }, KlaviyoSubscribe.loadJQueryForm = function(e) {
            KlaviyoSubscribe.loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery.form/3.32/jquery.form.min.js", function() {
                return !!window.jQuery && jQuery.fn.ajaxForm && jQuery.fn.formSerialize
            }, e)
        }, KlaviyoSubscribe.fetchRequirements = function(e) {
            if (document.getElementsByTagName("head"), e = e || {}, window.jQuery) jQuery.fn.ajaxForm ? KlaviyoSubscribe.processQueue() : KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue);
            else {
                var i = function() {
                    KlaviyoSubscribe.log("jQuery loaded."), KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue)
                };
                !0 === e.assume_jquery ? KlaviyoSubscribe.whenTrue(function() {
                    return !!window.jQuery
                }, i) : KlaviyoSubscribe.loadJQuery(i)
            }
        }, KlaviyoSubscribe.processQueue = function() {
            var e, i = function() {
                for (KlaviyoSubscribe.log("Processing queue."); e = KlaviyoSubscribe.bootstrap_queue.shift();) e();
                KlaviyoSubscribe.bootstrap_queue.push = function(e) {
                    e()
                }
            };
            KlaviyoSubscribe.log("Waiting for DOM to process queue."), jQuery(i), setTimeout(i, 5e3)
        }, KlaviyoSubscribe.executeWhenRequirementsLoaded = function(e) {
            KlaviyoSubscribe.bootstrap_queue.push(e)
        }, KlaviyoSubscribe.watchField = function(e, a, s) {
            (s = s || {}).type = s.type || "text", "email" !== a && "$email" !== a || (s.type = "email"), KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                KlaviyoSubscribe.log("Watching field", e, jQuery(e).length);
                var o = function(e) {
                    if (e = jQuery.trim($(e.target).val()), KlaviyoSubscribe.log("Watch field value", e), "email" !== s.type || i.test(e)) {
                        if (window._learnq && _learnq.push) {
                            var o = {};
                            o[a] = e, _learnq.push(["identify", o])
                        }
                        s.callback && s.callback(a, e)
                    }
                };
                s.delegate ? jQuery(s.delegate).on("change blur", e, o) : jQuery(e).on("change blur", o)
            })
        }, KlaviyoSubscribe.watchFormSubmission = function(e, i) {
            (i = i || {}).properties = i.properties || {}, i.list && (KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                if (i.properties) {
                    var a = [];
                    jQuery.each(i.properties, function(e, i) {
                        a.push(e)
                    }), a.length && (i.properties.$fields = a.join(","))
                }
                KlaviyoSubscribe.log("Watching form", e, jQuery(e).length);
                var s = function(e) {
                    var a = $(e.target);
                    if (window._learnq && _learnq.identify) {
                        var s = _learnq.identify();
                        if (s && (s = s.$email || s.email)) {
                            if (i.if) {
                                var o = jQuery(i.if);
                                if (!o.length || (o.is(":checkbox") ? !o.is(":checked") : !o.val())) return void KlaviyoSubscribe.log("Subscribe if fails", o)
                            }
                            s = jQuery.extend({
                                g: i.list,
                                email: s
                            }, i.properties), KlaviyoSubscribe.log("Subscribing", s), $.post("//manage.kmail-lists.com/ajax/subscriptions/subscribe", s), KlaviyoSubscribe._logMetric("submitModal", i.list), i.wait_seconds && (e.preventDefault(), setTimeout(function() {
                                KlaviyoSubscribe.log("Submitting form", a), a.get(0).submit()
                            }, 1e3 * i.wait_seconds))
                        }
                    }
                };
                i.delegate ? jQuery(i.delegate).on("submit", e, s) : jQuery(e).on("submit", s)
            }))
        }, KlaviyoSubscribe.attachToForms = function(e, i) {
            var a = (i = i || {}).extra_properties || {};
            a.$source = a.$source || "$embed", KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                KlaviyoSubscribe.log("Attaching to forms", e, jQuery(e).length), jQuery(e).each(function() {
                    var e = jQuery(this),
                        s = e.data("ajax-submit");
                    s || (s = "//manage.kmail-lists.com/ajax/subscriptions/subscribe"), e.ajaxForm({
                        url: s,
                        type: "POST",
                        beforeSubmit: function(i, s, o) {
                            try {
                                if (!KlaviyoSubscribe.isFormValid(e)) return !1
                            } catch (i) {
                                return KlaviyoSubscribe.log(i), e.find(".error_message").show().html(i), e.trigger("klaviyo.subscribe.error"), !1
                            }
                            KlaviyoSubscribe.log("$source", a.$source), KlaviyoSubscribe.normalizeFormFields(i, e, a, o), KlaviyoSubscribe._logMetric("submitModal", i.find(function(e) {
                                return "g" === e.name
                            }).value), e.find(".klaviyo_submit_button").attr("disabled", !0)
                        },
                        success: function(a, s, o) {
                            e.find(".success_message, .error_message").hide(), e.find(".klaviyo_submit_button").attr("disabled", !1), a.success ? (KlaviyoSubscribe.setClosedModalCookie(), (s = e.find(".success_message").show()).length || (s = e.parent().find(".success_message").show()), window._learnq && _learnq.push && (o = e.find('[name="email"]').val()) && (_learnq.push(["identify", {
                                $email: o
                            }]), _learnq.push(["trackActivity"])), i.success_url ? window.location = i.success_url : (!0 !== i.custom_success_message && s.html(i.success_message || '<div class="klaviyo_header">Thanks for subscribing!</div><div class="klaviyo_subheader">Check your email for a confirmation message.</div>').end(), !0 === i.hide_form_on_success && (e.find(".klaviyo_field_group input, .klaviyo_form_actions").hide(), e.is(".klaviyo_horizontal_form") && e.find(".klaviyo_field_group").hide()), i.success && i.success(e, a.data), e.trigger("klaviyo.subscribe.success").resetForm())) : (KlaviyoSubscribe.log(a.errors), e.find(".error_message").show().html(a.errors.join(" ")), e.trigger("klaviyo.subscribe.error"))
                        }
                    }), KlaviyoSubscribe.log("Attached to form", this)
                })
            })
        }, KlaviyoSubscribe.attachModalSignUp = function(e) {
            (e = e || {}).pages = e.pages || [], e.excluded_pages = e.excluded_pages || [], e.delay_seconds = e.delay_seconds || .1, e.delay_num_pages = e.delay_num_pages || 0, e.content = e.content || {}, e.extra_properties = e.extra_properties || {}, e.extra_properties.$source = e.extra_properties.$source || "$modal", e.list && (KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.setHasClosedModalCookieName(e.has_closed_modal_cookie_name), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                var i = KlaviyoSubscribe._buildModalSignUp(e);
                i.find('[name="g"]').val(e.list), i.appendTo(jQuery("body")), KlaviyoSubscribe.attachToModalForm(i, {
                    list: e.list,
                    pages: e.pages,
                    excluded_pages: e.excluded_pages,
                    delay: e.delay_seconds,
                    delay_num_pages: e.delay_num_pages,
                    ignore_cookie: e.ignore_cookie,
                    extra_properties: e.extra_properties,
                    custom_success_message: !!e.content.success,
                    success_url: e.success_url,
                    success: function(i) {
                        i.hide(), e.success && e.success(i)
                    }
                })
            }))
        }, KlaviyoSubscribe._buildModalSignUp = function(i) {
            var s = i.content;
            if (s.fields = s.extra_fields || [], -1 === jQuery.inArray("$email", s.fields) && s.fields.unshift("$email"), s.element) return jQuery(s.element);
            var o = jQuery(e["modal.html"]).attr("id", "k_id_modal").find(".klaviyo_header").html(s.header || "Interested in our Newsletter?").end().find(".klaviyo_subscription_form").attr("action", i.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe").data("ajax-submit", i.ajax_subscribe_url || "//manage.kmail-lists.com/ajax/subscriptions/subscribe").end().find(".klaviyo_submit_button span").html(s.button || "Subscribe").end();
            s.clazz && o.addClass(s.clazz), s.styles && KlaviyoSubscribe.injectCSS(s.styles), !1 !== s.subheader && o.find(".klaviyo_subheader").html(s.subheader || "Stay in the know with news and promotions."), s.below_submit ? o.find(".klaviyo_below_submit").html(s.below_submit) : o.find(".klaviyo_below_submit").hide(), s.success && o.find(".success_message").html(s.success), !0 === i.ack && o.append(jQuery('<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'));
            var t = o.find(".klaviyo_fieldset");
            return jQuery.each(s.fields, function(e, i) {
                "string" == typeof i && (i = {
                    name: i
                }), i.type || (i.type = "$email" === i.name ? "email" : "text"), i.label || (i.label = a[i.name] || i.name);
                var s = "k_id_modal_" + i.name;
                t.append(jQuery('<div class="klaviyo_field_group" />').append(jQuery("<label />").attr("for", s).html(i.label)).append(jQuery("<input />").attr({
                    type: i.type,
                    id: s,
                    name: "$" === i.name[0] ? i.name.slice(1) : i.name
                })))
            }), i = s.fine_print || "", s.email_frequency && (i += " Our newsletter is delivered to your inbox " + s.email_frequency + "."), o.find(".klaviyo_fine_print").html(i), o
        }, KlaviyoSubscribe.attachToModalForm = function(e, i) {
            (i = i || {}).pages = i.pages || [], i.excluded_pages = i.excluded_pages || [], i.extra_properties = i.extra_properties || {}, i.extra_properties.$source = i.extra_properties.$source || "$modal", void 0 === i.delay_seconds && (i.delay_seconds = void 0 === i.delay ? 2 : i.delay), KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.setHasClosedModalCookieName(i.has_closed_modal_cookie_name), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                var a = jQuery(e);
                KlaviyoSubscribe.attachToForms(jQuery(e).find(".klaviyo_subscription_form"), i), a.delegate(".klaviyo_close_modal", "click", function(e) {
                    e.preventDefault(), a.hide(), KlaviyoSubscribe.setClosedModalCookie(), KlaviyoSubscribe._logMetric("closeModal", i.list)
                }), a.click(function(e) {
                    e.currentTarget === e.target && (a.hide(), KlaviyoSubscribe.setClosedModalCookie())
                }), KlaviyoSubscribe._canShowElem(i) && jQuery(function() {
                    setTimeout(function() {
                        KlaviyoSubscribe._logMetric("openModal", i.list), a.fadeIn(1e3), a.trigger("klaviyo.modal.show")
                    }, 1e3 * i.delay_seconds)
                })
            })
        }, KlaviyoSubscribe.attachFlyoutSignUp = function(e) {
            (e = e || {}).pages = e.pages || [], e.excluded_pages = e.excluded_pages || [], e.delay_scroll = void 0 === e.delay_scroll ? 50 : e.delay_scroll, e.delay_seconds = e.delay_seconds || .1, e.delay_num_pages = e.delay_num_pages || 0, e.position = e.position || "right", e.content = e.content || {}, e.extra_properties = e.extra_properties || {}, e.extra_properties.$source = e.extra_properties.$source || "$flyout", void 0 === e.modal_content && (e.modal_content = e.content), e.list && (KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.setHasClosedModalCookieName(e.has_closed_modal_cookie_name), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                var i = !1 === e.modal_content,
                    a = KlaviyoSubscribe._buildFlyoutSignUp(jQuery.extend({
                        include_form: i
                    }, e));
                if (a.appendTo(jQuery("body")), i) {
                    var s = e.success;
                    e.success = function(e) {
                        e.hide(), KlaviyoSubscribe.setClosedModalCookie(), s && s(e)
                    }, e.custom_success_message = !!e.content.success, a.find('[name="g"]').val(e.list), KlaviyoSubscribe.attachToForms(a.find(".klaviyo_subscription_form"), e)
                }
                KlaviyoSubscribe.attachToFlyout(a, {
                    list: e.list,
                    pages: e.pages,
                    excluded_pages: e.excluded_pages,
                    delay: e.delay_seconds,
                    delay_scroll: e.delay_scroll,
                    delay_num_pages: e.delay_num_pages,
                    position: e.position,
                    ignore_cookie: e.ignore_cookie,
                    extra_properties: e.extra_properties,
                    click: function(i) {
                        (i = KlaviyoSubscribe._buildModalSignUp({
                            content: e.modal_content
                        })).find('[name="g"]').val(e.list), i.appendTo(jQuery("body")), KlaviyoSubscribe.attachToModalForm(i, {
                            list: e.list,
                            delay: .01,
                            extra_properties: e.extra_properties,
                            success_url: e.success_url,
                            success: function(i) {
                                i.hide(), e.success && e.success(i)
                            }
                        })
                    }
                })
            }))
        }, KlaviyoSubscribe._buildFlyoutSignUp = function(i) {
            var a = i.content;
            if (a.element) return jQuery(a.element);
            var s = jQuery(e[i.include_form ? "flyout_form.html" : "flyout.html"]).attr("id", "k_id_flyout").find(".klaviyo_header").html(a.header || "Interested in our Newsletter?").end().find(".klaviyo_subscription_form").attr("action", i.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe").data("ajax-submit", i.ajax_subscribe_url || "//manage.kmail-lists.com/ajax/subscriptions/subscribe").end().find(".klaviyo_flyout_action a span, .klaviyo_submit_button span").html(a.button || "Subscribe").end();
            return s.addClass("klaviyo_" + i.position), a.clazz && s.addClass(a.clazz), a.styles && KlaviyoSubscribe.injectCSS(a.styles), !1 !== a.subheader && s.find(".klaviyo_subheader").html(a.subheader || "Stay in the know with news and promotions."), a.success && s.find(".success_message").html(a.success), !0 === i.ack && s.find(".klaviyo_inner").append(jQuery('<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>')), s
        }, KlaviyoSubscribe.attachToFlyout = function(e, i) {
            (i = i || {}).pages = i.pages || [], i.excluded_pages = i.excluded_pages || [], i.position = i.position || "right", i.extra_properties = i.extra_properties || {}, i.extra_properties.$source = i.extra_properties.$source || "$flyout", KlaviyoSubscribe.bootstrap(), KlaviyoSubscribe.setHasClosedModalCookieName(i.has_closed_modal_cookie_name), KlaviyoSubscribe.executeWhenRequirementsLoaded(function() {
                var a = jQuery(e);
                a.delegate(".klaviyo_close_flyout", "click", function(e) {
                    e.preventDefault(), a.hide(), KlaviyoSubscribe.setClosedModalCookie(), KlaviyoSubscribe._logMetric("closeModal", i.list)
                }), a.find(".klaviyo_flyout_action a").click(function(e) {
                    e.preventDefault(), a.hide(), i.click && i.click()
                }), KlaviyoSubscribe._canShowElem(i) && jQuery(function() {
                    var e = i.delay_scroll,
                        s = function() {
                            if (!a.data("opened")) {
                                var e = i.delay_seconds || i.delay;
                                void 0 === e && (e = 2), setTimeout(function() {
                                    if (!a.data("opened")) {
                                        a.data("opened", !0), a.trigger("klaviyo.flyout.show");
                                        var e, s = a.find(".klaviyo_inner"),
                                            o = -1 < jQuery.inArray(i.position, ["left", "right", "bottom", "top"]) ? i.position : "right",
                                            t = {};
                                        t[o] = 0, a.css("visibility", "hidden").show(), KlaviyoSubscribe._logMetric("openModal", i.list), "left" === o ? e = 1.2 * -s.width() : "right" === o ? e = 1.2 * -s.width() : "top" === o ? e = 1.2 * -s.height() : "bottom" === o && (e = 1.2 * -s.height()), s.css(o, e), a.css("visibility", "visible"), s.animate(t, 1e3 * (i.slide_seconds || 2))
                                    }
                                }, 1e3 * e)
                            }
                        };
                    if (!1 === e || 0 === e) s();
                    else {
                        var o = jQuery(document),
                            t = jQuery(window),
                            r = "bottom" === e ? 95 : e,
                            l = function() {
                                var e = o.height() - t.height();
                                (0 > e ? 100 : 100 * o.scrollTop() / e) > r && (s(), o.unbind("scroll", l))
                            };
                        o.scroll(l)
                    }
                })
            })
        }, KlaviyoSubscribe.isFormValid = function(e) {
            var i = e.find('[name="email"]').val();
            if (!i || !/@/.test(i)) throw KlaviyoSubscribe.log("Invalid email address"), "Invalid email address";
            return e.find('input[required="true"], select[required="true"]').each(function(i, a) {
                if ((a = jQuery(a)).is(":radio") || a.is(":checked")) {
                    if (has_value = !!e.find('[name="' + a.attr("name") + '"]:checked').length, !has_value) throw KlaviyoSubscribe.log("Required field missing", a.attr("name")), "Required field missing: " + a.attr("name");
                    return has_value
                }
                if (!a.val()) throw KlaviyoSubscribe.log("Required field missing", a.attr("name")), "Required field missing: " + a.attr("name")
            }), e.find(".select-date-widget").each(function(e, i) {
                i = jQuery(i);
                var a = KlaviyoSubscribe._int(i.find('[name$="_day"]').val()),
                    s = KlaviyoSubscribe._int(i.find('[name$="_month"]').val()),
                    o = KlaviyoSubscribe._int(i.find('[name$="_year"]').val());
                if (!(isNaN(a) || isNaN(s) || isNaN(o))) {
                    switch (s) {
                        case 1:
                        case 3:
                        case 5:
                        case 7:
                        case 8:
                        case 10:
                        case 12:
                            if (1 <= a && 31 >= a) return;
                        case 4:
                        case 6:
                        case 9:
                        case 11:
                            if (1 <= a && 30 >= a) return;
                        case 2:
                            if (1 <= a && a <= (o % 4 ? 28 : 29)) return
                    }
                    throw KlaviyoSubscribe.log("Invalid date", o, s, a), "Invalid date"
                }
            }), !0
        }, KlaviyoSubscribe.normalizeFormFields = function(e, i, a, s) {
            e.push({
                name: "$timezone_offset",
                type: "text",
                value: this._getUtcOffset()
            });
            var o, t = [];
            jQuery.each(a, function(i, a) {
                e.push({
                    name: i,
                    type: "text",
                    value: a
                }), t.push(i)
            }), t.length && (jQuery.each(e, function(e, i) {
                if ("$fields" === i.name) return o = i, !1
            }), o ? o.value += "," + t.join() : e.push({
                name: "$fields",
                type: "text",
                value: t.join()
            })), i.find(".select-date-widget").each(function(i, a) {
                var s = (a = jQuery(a)).find('[name$="_day"]'),
                    o = a.find('[name$="_month"]'),
                    t = a.find('[name$="_year"]'),
                    r = s.attr("name"),
                    l = o.attr("name"),
                    n = t.attr("name");
                s = KlaviyoSubscribe._int(s.val()), o = KlaviyoSubscribe._int(o.val()), t = KlaviyoSubscribe._int(t.val());
                if (!(isNaN(s) || isNaN(o) || isNaN(t))) {
                    for (i = 0; i < e.length;) {
                        var c = e[i];
                        !c || c.name !== r && c.name !== l && c.name !== n ? i++ : e.splice(i, 1)
                    }
                    e.push({
                        name: r.replace("_day", ""),
                        required: !0,
                        type: "text",
                        value: KlaviyoSubscribe._formatDate(t, o, s)
                    })
                }
            })
        }, KlaviyoSubscribe.isCurrentLocationInPatterns = function(e) {
            for (var i = location.toString(), a = 0, s = e.length; a < s; a++)
                if (KlaviyoSubscribe.patternMatchesUrl(e[a], i)) return !0;
            return !1
        }, KlaviyoSubscribe.patternMatchesUrl = function(e, i) {
            if (e === (i = i.toLowerCase())) return !0;
            if (-1 === e.indexOf("?")) {
                var a = i.indexOf("?"); - 1 !== a && (i = i.substring(0, a))
            }
            return -1 === e.indexOf("*") ? ("" === (e = e.replace(/\/$/, "")) && (e = "/"), e === (i = i.replace(/\/$/, "")) || 0 === e.indexOf("/") && (a = KlaviyoSubscribe.parseDomain(i), "" === e ? "/" === a : a === e)) : e === i || !!e.length && (a = e.replace(/[.+?|()\[\]{}\\]/g, "\\$&").replace(/\*/g, "(.*?)"), a = /\/$/.test(a) ? "^" + a + "$" : "^" + a + "/?$", !!(a = RegExp(a, "i")).test(i) || !e.indexOf("/") && a.test(KlaviyoSubscribe.parseDomain(i)))
        }, KlaviyoSubscribe.parseDomain = function(e) {
            return "/" + e.split("//")[1].split("/").splice(1).join("/")
        }, KlaviyoSubscribe.incrPageViews = function() {
            var e = parseInt(KlaviyoSubscribe._getCookie("klaPages"), 10);
            return isNaN(e) && (e = 0), e += 1, KlaviyoSubscribe._setCookie("klaPages", e, 31536e6), e
        }, KlaviyoSubscribe.setClosedModalCookie = function() {
            KlaviyoSubscribe._setCookie(s, "1", 31536e6)
        }, KlaviyoSubscribe.resetClosedModalCookie = function() {
            KlaviyoSubscribe._deleteCookie(s)
        }, KlaviyoSubscribe.hasClosedModal = function() {
            return !!KlaviyoSubscribe._getCookie(s) && !KlaviyoSubscribe.isDebugMode()
        }, KlaviyoSubscribe._setCookie = function(e, i, a) {
            a = new Date((new Date).getTime() + a), document.cookie = e + "=" + i + ";expires=" + a.toGMTString() + ";path=/"
        }, KlaviyoSubscribe._getCookie = function(e) {
            return (e = RegExp("(^|;)[ ]*" + e + "=([^;]*)").exec(document.cookie)) ? e[2] : ""
        }, KlaviyoSubscribe._deleteCookie = function(e) {
            KlaviyoSubscribe._getCookie(e) && KlaviyoSubscribe._setCookie(e, "", -1)
        }, KlaviyoSubscribe._getUtcOffset = function() {
            return (new Date).getTimezoneOffset() / -60
        }, KlaviyoSubscribe._canShowElem = function(e) {
            return !(e.delay_num_pages && e.delay_num_pages > KlaviyoSubscribe.incrPageViews() || e.pages.length && !KlaviyoSubscribe.isCurrentLocationInPatterns(e.pages) || e.excluded_pages.length && KlaviyoSubscribe.isCurrentLocationInPatterns(e.excluded_pages)) && (e.ignore_cookie || !KlaviyoSubscribe.hasClosedModal())
        }, KlaviyoSubscribe._int = function(e) {
            return parseInt(e, 10)
        }, KlaviyoSubscribe._formatDate = function(e, i, a) {
            return 1 === a.toString().length && (a = "0" + a), 1 === i.toString().length && (i = "0" + i), e + "-" + i + "-" + a
        }, KlaviyoSubscribe.log = function() {
            if(KlaviyoSubscribe._debug) {
                window.console && console.log && console.log(arguments)
            }
        }, KlaviyoSubscribe._logMetric = function(e, i) {}, Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
            value: function(e, i) {
                if (null == this) throw new TypeError('"this" is null or not defined');
                var a = Object(this),
                    s = a.length >>> 0;
                if ("function" != typeof e) throw new TypeError("predicate must be a function");
                for (var o = 0; o < s;) {
                    var t = a[o];
                    if (e.call(i, t, o, a)) return t;
                    o++
                }
            }
        })
    }
}();